import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", { class: "page-name" }, "マニュアルダウンロード", -1)
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-d-flex p-jc-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              label: "ダウンロード",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fncClickDownload())),
              class: "p-mr-2 p-mt-2",
              style: {"width":"150px"}
            })
          ])
        ])
      ])
    ])
  ], 64))
}